import { render, staticRenderFns } from "./UploadsErrorForm.vue?vue&type=template&id=5ef16a32&scoped=true&"
import script from "./UploadsErrorForm.vue?vue&type=script&lang=js&"
export * from "./UploadsErrorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef16a32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
